export default "__VITE_ASSET__BrTrOCJG__"